const Setting = {
    id: '',
    attr: '',
    val: '',
    campusId: ''
};

export default Setting;